import { gql } from '@apollo/client';

export const GET_EQUIPMENTS = gql`
  query equipments {
    equipments {
      id
      name
      description
      size
      bags {
        bag {
          id
          name
          qrCode
        }
      }
      createdAt
      updatedAt
    }
  }
`;